(function () {
  const compassBtn = document.querySelector('.header__icon--compass');
  const modal = document.getElementById('compass-modal');
  const closeBtn = document.getElementById('compass-modal-close');
  const backdrop = document.getElementById('compass-modal-backdrop');

  if (!compassBtn || !modal) return;

  // Capture-phase listeners that block footer scroll/wheel handlers while modal is open
  function blockFooterScroll(e) {
    e.stopImmediatePropagation();
  }

  // Stop touch events from bubbling out of the panel to the window-level footer handler.
  const panel = modal.querySelector('.compass-modal__panel');
  if (panel) {
    panel.addEventListener('touchstart', (e) => e.stopPropagation(), { passive: true });
    panel.addEventListener('touchmove',  (e) => e.stopPropagation(), { passive: true });
  }

  function openModal() {
    // Close the footer newsletter panel if it is open
    const footerSubscribe   = document.getElementById('footer-subscribe');
    const btnCloseSubscribe = document.getElementById('btn-close-subscribe');
    if (footerSubscribe && footerSubscribe.classList.contains('active') && btnCloseSubscribe) {
      btnCloseSubscribe.click();
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    window.addEventListener('scroll', blockFooterScroll, { capture: true });
    window.addEventListener('wheel',  blockFooterScroll, { capture: true });

    requestAnimationFrame(updateProductsArrow);
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';

    window.removeEventListener('scroll', blockFooterScroll, { capture: true });
    window.removeEventListener('wheel',  blockFooterScroll, { capture: true });

    compassBtn.focus();
  }

  compassBtn.addEventListener('click', openModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (backdrop) backdrop.addEventListener('click', closeModal);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // Products carousel
  const productsWrapper = document.getElementById('compass-products-wrapper');
  const productsTrack   = document.getElementById('compass-products-track');
  const productsNextBtn = productsWrapper && productsWrapper.querySelector('.compass-modal__products-arrow--next');

  function updateProductsArrow() {
    if (!productsNextBtn || !productsWrapper || !productsTrack || window.innerWidth < 990) return;
    const atEnd = productsTrack.scrollLeft + productsTrack.clientWidth >= productsTrack.scrollWidth - 4;
    productsWrapper.classList.toggle('has-next-arrow', !atEnd);
  }

  if (productsWrapper && productsTrack && productsNextBtn) {
    productsNextBtn.addEventListener('click', () => {
      const firstCard = productsTrack.firstElementChild;
      const gap = parseFloat(getComputedStyle(productsTrack).columnGap) || 0;
      const scrollAmount = firstCard ? firstCard.offsetWidth + gap : 151;

      const maxScroll = productsTrack.scrollWidth - productsTrack.clientWidth;
      if (productsTrack.scrollLeft >= maxScroll - 4) {
        productsTrack.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        productsTrack.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    });

    productsTrack.addEventListener('scroll', updateProductsArrow);

    // Debounced to avoid thrashing on every resize pixel
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateProductsArrow, 150);
    });

    // Mouse drag — desktop/tablet only (≥768px); touch is handled separately below
    if (window.innerWidth >= 768) {
      let isDragging   = false;
      let dragStartX   = 0;
      let dragScrollLeft = 0;
      let hasDragged   = false;

      productsTrack.addEventListener('mousedown', (e) => {
        isDragging     = true;
        hasDragged     = false;
        dragStartX     = e.pageX;
        dragScrollLeft = productsTrack.scrollLeft;
        productsTrack.style.userSelect = 'none';
        e.preventDefault();
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const delta = e.pageX - dragStartX;
        if (Math.abs(delta) > 3) hasDragged = true;
        productsTrack.scrollLeft = dragScrollLeft - delta;
        updateProductsArrow();
      });

      document.addEventListener('mouseup', () => {
        if (!isDragging) return;
        isDragging = false;
        productsTrack.style.userSelect = '';
      });

      productsTrack.addEventListener('click', (e) => {
        if (hasDragged) {
          e.preventDefault();
          hasDragged = false;
        }
      }, true);
    }
  }

  // Touch drag — all screen sizes (mobile + touch-enabled desktop)
  if (productsTrack) {
    let touchStartX   = null;
    let touchStartY   = null;
    let touchScrollLeft  = 0;
    let touchAxisLocked  = null; // 'x' | 'y' | null

    productsTrack.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      touchStartX    = e.touches[0].clientX;
      touchStartY    = e.touches[0].clientY;
      touchScrollLeft = productsTrack.scrollLeft;
      touchAxisLocked = null;
    }, { passive: true });

    productsTrack.addEventListener('touchmove', (e) => {
      if (touchStartX === null) return;
      // On mobile, native browser scroll (pan-x) handles horizontal swiping;
      // manual scrollLeft is only needed on desktop where overflow:hidden is set.
      if (window.innerWidth < 990) return;
      const dx = e.touches[0].clientX - touchStartX;
      const dy = Math.abs(e.touches[0].clientY - touchStartY);

      if (!touchAxisLocked) {
        if (Math.abs(dx) > 5 || dy > 5) {
          touchAxisLocked = Math.abs(dx) >= dy ? 'x' : 'y';
        }
        if (!touchAxisLocked) return;
      }

      if (touchAxisLocked === 'x') {
        productsTrack.scrollLeft = touchScrollLeft - dx;
        updateProductsArrow();
        e.preventDefault();
      }
      // touchAxisLocked === 'y': let the event propagate so the modal body scrolls
    }, { passive: false });

    const resetTouch = () => { touchStartX = null; touchAxisLocked = null; };
    productsTrack.addEventListener('touchend',    resetTouch, { passive: true });
    productsTrack.addEventListener('touchcancel', resetTouch, { passive: true });
  }
})();
